import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'

import { Sort } from './Sort'
import { Select } from './Select'

const Container = styled.div`
  align-content: flex-end;
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  height: 50px;
`

const OrderBy: FC = () => (
  <Container>
    <Select />
    <Sort />
  </Container>
)

export { OrderBy }
